import { z } from 'zod'

import { DateZod } from '../common'
import { PromotionPlacementZod } from '../promotions/promotions-zod'

export const PromotionTrackingZod = z.object({
  userId: z.string().optional(),
  firebaseInstallationId: z.string().optional(),
  regionId: z.string(),
  regionName: z.string(),
  initiativeId: z.string(),
  promotionId: z.string(),
  partnerName: z.string(),
  promotionTitle: z.string(),
  promotionType: z.enum(['local', 'national', 'fallback']),
  placement: PromotionPlacementZod,
  event: z.enum(['view', 'click', 'share', 'send']),
  createdAt: DateZod,
})
export type PromotionTracking = z.infer<typeof PromotionTrackingZod>
